module.exports = __webpack_public_path__ + "static/img/live-no-data.afb30271.svg";